import { render, staticRenderFns } from "./FormSetupStreamax.vue?vue&type=template&id=49c7f85f&scoped=true&"
import script from "./FormSetupStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormSetupStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormSetupStreamax.vue?vue&type=style&index=0&id=49c7f85f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7f85f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('49c7f85f', component.options)
    } else {
      api.reload('49c7f85f', component.options)
    }
    module.hot.accept("./FormSetupStreamax.vue?vue&type=template&id=49c7f85f&scoped=true&", function () {
      api.rerender('49c7f85f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Network/FormSetupStreamax.vue"
export default component.exports